var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookmark48Filled = function SvgIconBookmark48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 9.3H16.6a5.3 5.3 0 0 0-5.3 5.3v21.2a2.87 2.87 0 0 0 1.42 2.49 2.87 2.87 0 0 0 2.87 0L24 33.7l8.41 4.59a2.899 2.899 0 0 0 4.29-2.54v-21.2a5.3 5.3 0 0 0-5.3-5.25Z",
    fill: "current"
  })));
};
export default SvgIconBookmark48Filled;